module.exports = __webpack_public_path__ + "img/hamburguesas_all.95ca6176.jpeg";